<template>
  <div class="shops">
    <div class="main">
      <router-link class="backlink button" :to="{name: 'ShopFinder'}"><img src="@/assets/chevleft.svg" alt=""> {{languageStrings['Übersicht']}}</router-link>
      <h2 v-html="headline"></h2>
      <div class="shop-window" v-if="getShops.length">
        <div class="shops-container " :style="{left: paginationOffset}">
          <div class="shoprow" v-for="shop in getShops" v-bind:key="shop.id" >
            <router-link class="" :to="{name: 'ShopDetails', params: { id: shop.id, shop: shop, backlink: '/shops/' + filterType + '/' + filterValue }}">
              <div class="shopcolour" :class="houseColorClass(shop.house.substr(0,1))"></div>
              <div class="name" v-html="shop.name"> </div>
              <div class="location">
                <img src="@/assets/pingray.svg" alt=""> <span class="capitalise">{{languageStrings['haus']}}</span> {{shop.house}}, {{languageStrings['Ebene']}} {{shop.level}}
              </div>
              <div class="time">
                <img src="@/assets/walkingman.svg" alt=""> {{getDistance(shop)}} min
              </div>
              <div class="button btn-orange">
                {{ languageStrings.starten }}
              </div>
              <div class="line"></div>
            </router-link>
          </div>
        </div>
      </div>

      <div class="new-shop-empty-container" v-if="getShops.length < 1 && filterType == 'new'">
        <h3>Alles beim Alten</h3>
        <h3 class="gray" v-html="languageStrings.nonewshops"></h3>

        <h3>Shops {{languageStrings['nach Branchen']}}</h3>
        <div class="flex-row">
          <div class="branches">
            <router-link v-for="filter in store.categories" :key="filter.term_id" :to="{name: 'Shops', params: { filter: 'category', filterValue: filter.term_id, name: filter.name }}" class="button">{{ filter.name }}</router-link>
          </div>
        </div>
      </div>

      <div class="pagination">
        <div class="button" v-for="n in navigationButtons" v-bind:key="n" :class="{ active: currentPage == n }" v-on:click="paginate(n)">{{n}}</div>
      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import Advertising from "../../components/Advertising";
import { nodes, servicePoints, getActiveHouses, getDirectionHouses, navigate, startDescriptions, parseNode } from '@/nodes.js'
export default {
  name: 'Shoplist',
  components: {
    Advertising
  },
  data: function(){
    return {
      filterType: this.$route.params.filter,
      filterValue: this.$route.params.filterValue,
      // headline: this.$route.params.headline,
      activeShops: [],
      currentPage: 1,
      paginationOffset: '0px',
      routes: false
    }
  },
  props: ['store', 'languageStrings', 'location', 'currentLanguage', 'options'],
  created() {
    this.routes = navigate(this.options.location)
  },
  computed: {
    getShops: function () {
      if ( this.filterType === 'alpha' ){
        let filterValue = this.filterValue;
        return this.store.shops.filter(function (el) {
          return filterValue.indexOf(el.name.charAt(0).toLowerCase() ) > -1;
        })
      }
      else if ( this.filterType === 'house' ) {

        let filterValue = this.filterValue;
        return this.store.shops.filter(function (el) {
          return parseInt(el.house) == filterValue;
        })
      }
      else if ( this.filterType === 'category' ) {
        var filterValue = parseInt(this.filterValue);
        return this.store.shops.filter(function (el) {
          if ( 'categories' in el){
            return el.categories.indexOf(filterValue) > -1;
          }

        })
      }
      else if ( this.filterType === 'new' ) {
        return this.store.shops.filter(function (el) {
          return el.isnew == true;
        })
      }

      else return [];

    },
    navigationButtons(){

      if (window.innerWidth > window.innerHeight){
        return Math.ceil(this.getShops.length / 5)
      } else {
        return Math.ceil(this.getShops.length / 8)
      }

    },
    headline(){
      if ( this.filterType === 'house' ){
        return this.languageStrings['haus'] + ' ' + this.filterValue
      }
      if ( this.filterType === 'new' ){
        return this.languageStrings['neue'] + ' Shops'
      }
      if ( this.filterType === 'alpha' ){
        return  'Shops ' + this.filterValue[0] + '-' + this.filterValue[this.filterValue.length - 1].toUpperCase()
      }
      if ( this.filterType === 'category' ){
        if (this.currentLanguage == 'de'){
          return  this.store.categories.find(x=> x.term_id == this.filterValue).name
        } else {
          return  this.store.categories.find(x=> x.term_id == this.filterValue).nameEN
        }

      }
    },


  },
  methods : {
    houseColorClass: function (house) {
      return "house" + house;
    },
    paginate(index){
      this.currentPage = index;
      let rowEl = document.getElementsByClassName('shoprow')
      if (rowEl.length){
        let width = rowEl[0].offsetWidth
        this.paginationOffset = (this.currentPage-1) * -width + 'px'
      }
    },
    getLevels(shop){
      if (  shop.shopnumbers && shop.shopnumbers.length ){
        let levelSring = ''
        if (shop.shopnumbers.length < 2){
          levelSring = shop.shopnumbers[0].substring(2,3)
        } else {
          shop.shopnumbers.forEach(function (el) {
            levelSring += el.substring(2,3)
            levelSring += ','
          })
        }
        return levelSring;
      }

    },
    getDistance(shop){
      let exit = this.store.exits[shop.shopnumbers[0]]
      // return exit;
      if (exit && this.routes[exit]){
        return Math.max(this.routes[exit].length, 3);
      }

      // if ( shop.shopnumbers.length > 0 ){
      //     let time = 0;
      //     let level = parseInt(shop.shopnumbers[0].substring(2,3));
      //     let house = parseInt(shop.shopnumbers[0].substring(0,1));
      //     time = Math.abs((level - this.location.level) * 5);
      //     time += Math.abs((house - this.location.house) * 1);
      //     return time;
      // }

    }

  },
}
</script>

<style scoped lang="scss">
@import "../../styles/variables";

.shops {
  padding-left: $advertisingPadding;

  @include portrait(){
    padding-left: 0px;
  }

}


.shop-window {
  height: 600px;
  width: 1047px;
  position: relative;
  overflow: hidden;

  @include portrait(){
    height: 960px;
    width: 713px;
  }

}

h2 {
  color: $gray2;
  text-transform: capitalize;

  @include portrait(){
    font-size: 40px;
  }

}

.shops-container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 100%;
  position: relative;
  transition: left 0.2s ease;
}

.pagination {
  display: flex;

  .button {
    padding: 10px 25px;
    &.active {
      background: white;
      border: 2px solid #6F6F6F;
    }
  }
}

.shoprow {
  a {
    display: flex;
    justify-content: flex-start;
    position: relative;
    padding: 20px 0px;
    align-items: center;
    width: 100%;
    height: 110px;
    color: inherit;
    padding-left: 2px;

    .line {
      border-bottom: 2px solid #6F6F6F;
      width: calc(100% - 50px);
      position: absolute;
      bottom: 0px;
    }

  }

  .shopcolour {
    display: block;
    width: 20px;
    height: 20px;
    margin-right: 20px;
    background: $blue;
    border-radius: 3px;
    position: relative;
    left: 1px;

    &.house1 {
      background: $blue;
    }
    &.house3 {
      background: $green;
    }
    &.house5 {
      background: $purple;
    }
    &.house7 {
      background: $yellow;
    }
    &.house9 {
      background: $rose;
    }
  }

  .name {
    font-weight: 700;
    color: #6F6F6F;
    width: 326px;
    overflow: hidden;
    @include fontSize(24, 35);
    @include portrait(){
      width: 314px;
    }
  }

  .location {
    position: relative;
    padding-left: 30px;

    width: 278px;


    img {
      margin-right: 10px;
      position: absolute;
      left: 0;
      top: -0px
    }

    @include portrait(){
      width: 128px;
      img {
        top: 10px;
      }
    }

  }

  .time {
    width: 182px;
    display: flex;
    img {
      margin-right: 10px;
    }
    @include portrait(){
      width: 92px;
    }
  }

  .button {
    margin: 0;
    padding: 10px 30px;
    width: 169px;
    height: 50px;
    font-weight: bold;
    background: $orange;
    color: white;
    border-radius: 50px;
    margin-right: 50px;

    @include portrait(){
      padding: 10px 18px;
      width: 130px;
    }

    @include buttonActive;

    img {
      margin-right: 20px;
      @include portrait(){
        margin-right: 10px;
      }
    }
    .chev {
      width: 8px;
      transform: rotate(180deg);
      margin: 0;
      margin-left: 10px;
      position: relative;
      top: 2px;

      @include portrait(){
        margin-left: 8px;
      }

    }

    @include portrait(){
      width: 131px;
    }
  }


}

.flex-row {

  @include portrait(){
    flex-wrap: wrap;
  }

  > div {
    display: flex;
    flex-wrap: wrap;
    h3 {
      width: 100%;
    }
  }
}

.new-shop-empty-container {
  padding-top: 60px;
  h3 {
    font-size: 24px;
    max-width: 800px;

    &.gray {
      color: $gray2;
      margin-bottom: 60px;
    }

  }

  .branches {
    max-width: 1000px;
    .button {
      padding: 17px 76px;
      @include buttonActive;
      @include portrait(){
        padding: 17px 40px;
      }
    }
  }
}

</style>






